import { render, staticRenderFns } from "./CollectingReceiptForm.vue?vue&type=template&id=4212ab39"
import script from "./CollectingReceiptForm.vue?vue&type=script&lang=js"
export * from "./CollectingReceiptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports